import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-email-confirmation',
    imports: [MatIconModule, MatButtonModule, RouterLink],
    templateUrl: './email-confirmation.component.html',
    styleUrl: './email-confirmation.component.scss',
})
export class EmailConfirmationComponent {
    // private _route = inject(ActivatedRoute);
    // hasError = false;
    // errorMessage = '';
    // ngOnInit(): void {
    //     // 1. Check the query parameters in the URL
    //     const status = this._route.snapshot.queryParamMap.get('status');
    //     const msg = this._route.snapshot.queryParamMap.get('msg');
    //     // 2. Set the flag if status is 'error'
    //     if (status === 'error') {
    //         this.hasError = true;
    //         this.errorMessage = msg || 'An unexpected error occurred.';
    //     }
    // }
}
